import type { RouteRecordRaw } from 'vue-router';

export default <RouteRecordRaw[]>[
  {
    path: 'products-and-services',
    name: 'products-and-services',
    component: () => import('./views/ProductsAndServices.view.vue'),
  },
];
